<template>
  <v-layout column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        rounded
        fab
        text
        color="primary"
        :to="{ name: 'Products'}">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">Regresar a productos</div>
      <v-spacer />
      <div class="d-flex justify-end align-center mr-3">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar producto"
          solo
          hide-details
          rounded
          flat
          dense />
      </div>
    </div>
    <v-flex xs12>
      <v-container>
        <v-data-table
          loading-text="Cargando variantes duplicadas..."
          no-data-text="No se encontraron variantes duplicadas"
          :server-items-length="table.total"
          :loading="table.loading"
          :headers="table.headers"
          :items="table.data"
          :options="table.options"
          :footer-props="{ 'items-per-page-options': [10,20,50] }"
          @update:options="updateTable"
          class="elevation-1">
          <template v-slot:item.externalId="{ item }">
            <span>
              {{ item.externalId }}
            </span>
          </template>
          <template v-slot:item.name="{ item }">
            {{ item.name }}
          </template>
          <template v-slot:item.status="{ item }">
            {{ statusProduct(item.status) }}
          </template>
          <template v-slot:item.type="{ item }">
            {{ typeProduct(item.type) }}
          </template>
          <template v-slot:item.duplicates="{ item }">
            {{ item.duplicatedVariants.length || 0 }}
          </template>
          <template v-slot:item.actions="{ item }">
            <div class="d-flex justify-end align-center">
              <v-tooltip left>
                <template
                  v-slot:activator="{ on }">
                  <v-icon
                    dense
                    class="mr-2"
                    color="secondary"
                    v-on="on"
                    @click="onOpenDuplicateVariants(item)"
                  >
                    mdi-magnify
                  </v-icon>
                </template>
                <span>Abrir variantes duplicadas</span>
              </v-tooltip>
            </div>
          </template>
        </v-data-table>
      </v-container>
    </v-flex>

    <DuplicatePricesModal
      :data="duplicatePrices"
      ref="duplicatePricesModal"
      @submit="load"
      @close="onCloseDuplicateVariants"
    />

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import { cloneDeep, debounce } from 'lodash'
import DuplicatePricesModal from '@/components/modals/DuplicatePrices'

export default {
  components: {
    DuplicatePricesModal
  },
  name: 'DuplicatePricesList',
  data () {
    return {
      overlay: false,
      disabled: true,
      createDialog: false,
      updateDialog: false,
      removeDialog: false,
      status: [],
      table: {
        title: 'Cargando datos de contacto...',
        loading: false,
        headers: [
          { text: 'Id externo', value: 'externalId', sortable: false },
          { text: 'Nombre', value: 'name', sortable: true },
          { text: 'Departamento', value: 'category', sortable: true },
          { text: 'Estatus', value: 'status', sortable: false },
          { text: 'Tipo de producto', value: 'type', sortable: false },
          { text: 'Variantes duplicadas', value: 'duplicates', sortable: false },
          { text: 'Acciones', value: 'actions', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 10,
          page: 1,
          sortBy: ['name'],
          sortDesc: []
        }
      },
      duplicatePrices: null,
      search: ''
    }
  },
  computed: {
    provider () {
      return this.$store.state.currentProvider.data._id || null
    }
  },
  async mounted () {
    await this.load()
  },
  watch: {
    'search': debounce(async function (val) {
      if (val.length >= 3) {
        try {
          const params = {
            name: val,
            limit: this.table.options.itemsPerPage,
            skip: (this.table.options.itemsPerPage * (this.table.options.page - 1))
          }
          await this.load(params)
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        await this.load()
      }
    }, 300)
  },
  methods: {
    async submit () {
      if (this.$refs.formContact.validate()) {
        this.overlay = true
        try {
          const form = new FormData()
          form.append('concept', this.form.contact.concept.value)
          form.append('name', this.form.contact.name)
          form.append('email', this.form.contact.email)
          form.append('phone', this.form.contact.phone)

          await this.$api.post(`/v1/providers/contact`, form)

          this.$toasted.show('Los datos se guardaron con éxito', { duration: 3000 })
          this.load()
          this.onCloseCreateDialog()
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
        this.overlay = false
      }
    },
    async load (params = null) {
      params = params || {
        limit: this.table.options.itemsPerPage,
        skip: (this.table.options.itemsPerPage * (this.table.options.page - 1)),
        sort: `${this.table.options.sortDesc[0] ? '-' : ''}${this.table.options.sortBy[0]}`
      }
      this.table.loading = true
      try {
        const response = await this.$api.get(`/v1/catalog/pricing/${this.provider}/listDuplicates`, params)
        this.table.data = response.data
        this.table.total = response.total
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    updateTable: async function (data) {
      this.table.options = data
      await this.load({
        limit: data.itemsPerPage,
        skip: (data.itemsPerPage * (data.page - 1)),
        sort: `${data.sortDesc[0] ? '-' : ''}${data.sortBy[0]}`
      })
    },
    onCloseDuplicateVariants: function () {
      this.duplicatePrices = null
    },
    onOpenDuplicateVariants: function (item) {
      this.duplicatePrices = cloneDeep(item)
      if (this.duplicatePrices && this.duplicatePrices.duplicatedVariants) {
        this.$refs.duplicatePricesModal.open()
      }
    },
    typeProduct (status) {
      return {
        product: 'Producto',
        service: 'Servicio'
      }[status]
    },
    statusProduct (status) {
      return {
        approved: 'Aprovado',
        'in-review': 'En revisión.',
        published: 'Publicado'
      }[status]
    }
  }
}
</script>
